// client/src/reducers/redmineAggregatedDataReducer.js

const initialState = {
  data: {
    projects: [],
    issues: [],
  },
  maxSubprojects: 0,
  loading: false,
  error: null,
};

const redmineAggregatedDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'FETCH_AGGREGATED_DATA_REQUEST':
      return { ...state, loading: true, error: null };
    case 'FETCH_AGGREGATED_DATA_SUCCESS':
      return {
        ...state,
        loading: false,
        data: {
          // If your server returns { data: [...], maxSubprojects: 3 }, 
          // make sure to adapt accordingly:
          projects: action.payload.data.projects || [],
          issues: action.payload.data.issues || [],
        },
        maxSubprojects: action.payload.maxSubprojects || 0,
      };
    case 'FETCH_AGGREGATED_DATA_FAILURE':
      return { ...state, loading: false, error: action.payload };
    case 'UPDATE_AGGREGATED_DATA':
      return {
        ...state,
        data: {
          projects: action.payload.data.projects || state.data.projects,
          issues: action.payload.data.issues || state.data.issues,
        },
        maxSubprojects: action.payload.maxSubprojects || state.maxSubprojects,
      };
    default:
      return state;
  }
};

export default redmineAggregatedDataReducer;
